import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Chip,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LoadingRows from "../LoadingRows";
import Input from "@mui/joy/Input";
import Button from "@mui/joy/Button";
import SendIcon from "@mui/icons-material/Send";
import ChatBox from "./ChatBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { BASE_URL } from "../../utils/BaseURL";

const Description = () => {
  const { ticketID } = useParams();
  const { user } = JSON.parse(localStorage.getItem("user")) || {};
  const [tickets, setTickets] = useState([]);
  const [getDataLoading, setGetDataLoading] = useState(false);
  const [content, setContent] = useState("");
  const [flag, setFlag] = useState(false);
  const [messages, setMessages] = useState();
  const navigate = useNavigate();

  const updateTicketsWithID = async (id, data) => {
    return await axios
      .patch(BASE_URL + `/tickets/update/${id}`, data, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  };

  const getTicketsByID = async (id) => {
    return await axios
      .get(BASE_URL + `/tickets/get-by-id/${id}`, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  };

  const getMessagesByID = async (ticketID) => {
    return await axios
      .get(BASE_URL + `/messages/get/${ticketID}`, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      ticketID: ticketID,
      sender: "User",
      content: content,
    };

    axios
      .post(`${BASE_URL}/messages/create`, data, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((res) => {
        if (res?.status == 200) {
          console.log(res);
          setContent("");
          setFlag(!flag);
          const update = {
            adminUpdate: false,
            userUpdate: true,
          };
          updateTicketsWithID(ticketID, update)
            .then((res) => {
              console.log(res);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setContent("");
        setFlag(!flag);
      });
  };

  useEffect(() => {
    setGetDataLoading(true);
    getTicketsByID(ticketID)
      .then((res) => {
        setTickets(res?.data);
        console.log(res);
        setGetDataLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setGetDataLoading(false);
      });
  }, [ticketID]);

  useEffect(() => {
    getMessagesByID(ticketID)
      .then((res) => {
        console.log(res);
        setMessages(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [flag]);

  return (
    <Box margin={"20px"}>
      <Box className="col">
        {/* Details */}
        {getDataLoading ? (
          <LoadingRows num={3} />
        ) : (
          <Paper elevation={3} style={{ padding: "10px" }}>
            <Card variant="outlined">
              <CardContent>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  textAlign={"center"}
                  mb={"5px"}
                >
                  <Box>
                    <Button onClick={() => navigate("/support")}>
                      <ArrowBackIcon /> Go Back
                    </Button>
                  </Box>
                  <Typography variant="h6">ID: {tickets?._id}</Typography>
                </Box>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Box>
                    {tickets?.orderId && (
                      <Typography variant="h6">
                        OrderId: {tickets?.orderId}
                      </Typography>
                    )}
                    <Typography variant="body1">
                      Name: {tickets?.userId?.name}
                    </Typography>
                    <Typography variant="body1">
                      Email: {tickets?.userId?.email}
                    </Typography>
                    <Typography variant="body1">
                      Phone: {tickets?.userId?.phoneNumber}
                    </Typography>
                    <Box label="Chip Filled" mb={"5px"}>
                      Ticket Status:{" "}
                      {tickets && tickets.ticketStatus === "Open" ? (
                        <Chip
                          style={{
                            backgroundColor: "green",
                            color: "white",
                          }}
                          label={tickets && tickets.ticketStatus}
                        />
                      ) : tickets && tickets.ticketStatus === "Waiting" ? (
                        <Chip
                          style={{
                            backgroundColor: "orange",
                            color: "white",
                          }}
                          label={tickets && tickets.ticketStatus}
                        />
                      ) : (
                        <Chip
                          style={{
                            backgroundColor: "red",
                            color: "white",
                          }}
                          label={tickets && tickets.ticketStatus}
                        />
                      )}
                    </Box>
                  </Box>
                </Box>
                <Accordion disabled={tickets?.description === ""}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Description</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>{tickets?.description}</Typography>
                  </AccordionDetails>
                </Accordion>
              </CardContent>
            </Card>
          </Paper>
        )}
        {/* Chat Screen */}
        <ChatBox messages={messages} notRole={"Admin"} />
        {/* Chat Input */}
        <Box bottom={20}>
          <form onSubmit={handleSubmit}>
            <Input
              sx={{
                "--Input-decoratorChildHeight": "45px",
                "--Input-decoratorChildWidth": "450px",
              }}
              placeholder="Send Messages..."
              style={{ margin: "auto", marginTop: "20px" }}
              type="text"
              value={content}
              required
              onChange={(e) => setContent(e.target.value)}
              endDecorator={
                <Button
                  variant="solid"
                  color="primary"
                  type="submit"
                  sx={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <SendIcon />
                </Button>
              }
            />
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default Description;
